import { combineReducers, configureStore } from "@reduxjs/toolkit";
import layersSlice from "./slices/layersSlice";
import optionsSlice from "./slices/optionsSlice";
import orderSlice from "./slices/orderSlice";
import mapSlice from "./slices/mapSlice";
import filtersSlice from "./slices/filtersSlice";
import leftNavSlice from "./slices/leftNavSlice";
import searchSlice from "./slices/searchSlice";
import exportSlice from "./slices/exportSlice";
import collectionSlice from "./slices/collectionSlice";
import authSlice, { logout } from "./slices/authSlice";
import providerSlice from "./slices/providerSlice";

const appReducer = combineReducers({
  auth: authSlice,
  map: mapSlice,
  layers: layersSlice,
  options: optionsSlice,
  filters: filtersSlice,
  leftNav: leftNavSlice,
  search: searchSlice,
  orderDetails: orderSlice,
  exportDetails: exportSlice,
  collectionDetails: collectionSlice,
  providerDetails: providerSlice,
});

const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    state = undefined; // Resets the entire state
  }

  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ignore non-serializable value warning
        ignoredActions: [
          'ordersSlice/setUploadedFeatures',
          'search/setSelectedFeature',
          'mapSlice/setMapRef',
          'mapSlice/setDrawRef'
        ],
        ignoredPaths: [
          'orderDetails.uploadedCollection',
          'search.selectedFeature',
          'map.mapRef',
          'map.drawRef'
        ],
      },
    }),
  devTools: {
    stateSanitizer: (state) => {
      const sanitizedState = { ...state };
      if (sanitizedState.map) {
        sanitizedState.map = {
          ...sanitizedState.map,
          mapRef: '<<mapRef>>',
          drawRef: '<<drawRef>>',
        };
      }
      return sanitizedState;
    },
    actionSanitizer: (action) => {
      if (action.type === 'mapSlice/setMapRef' || action.type === 'mapSlice/setDrawRef') {
        return {
          ...action,
          payload: '<<non-serializable>>',
        };
      }
      return action;
    },
  },
});